firebird.directive('meetingMarquee', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'marquee.html'),
            link: function (scope, element) {}
        };
    }
]);
